import { cartHeaderStyles } from "@insite/content-library/Widgets/Cart/CartHeader";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

cartHeaderStyles.gridItem1 = {
    width: [12, 12, 8, 9, 9],
    css: css`
        h1 {
            margin-bottom: 20px;
        }
    `,
};
cartHeaderStyles.gridItem2={
    width: [12, 12, 12, 3, 3],
}
